import { Component, OnInit, Input, Optional } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'viva-calendar-input',
  templateUrl: './viva-calendar-input.component.html',
  styleUrls: ['./viva-calendar-input.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, TranslateModule]
})
export class VivaCalendarInputComponent implements OnInit {
  @Input() initialDate?: string | null;
  @Input() minDate?: string;
  @Input() maxDate?: string;
  @Input() useUSFormat?: boolean;
  @Input() title?: string;

  selectedDate?: string;

  constructor(
    private modalController: ModalController,
    private translateService: TranslateService,
    @Optional() private navParams: NavParams
  ) {
    // Get component props from modal or @Input
    if (this.navParams) {
      this.initialDate = this.initialDate || this.navParams.get('initialDate');
      this.minDate = this.minDate || this.navParams.get('minDate');
      this.maxDate = this.maxDate || this.navParams.get('maxDate');
      this.useUSFormat = this.useUSFormat !== undefined ? this.useUSFormat : this.navParams.get('useUSFormat');
      this.title = this.title || this.navParams.get('title');
    }
  }

  ngOnInit() {
    // Initialize selected date with initial date if available
    if (this.initialDate && !this.selectedDate) {
      this.selectedDate = this.initialDate;
    }
  }

  onDateChange(event: any) {
    if (event.detail && event.detail.value) {
      this.selectedDate = event.detail.value;
    }
  }

  async confirm() {
    await this.modalController.dismiss({
      selectedDate: this.selectedDate || this.initialDate
    });
  }

  async close() {
    await this.modalController.dismiss();
  }

  getTitleText(): string {
    if (this.title) {
      return this.title;
    }
    return this.translateService.instant('questionnaire-form-page.form.select-date-time');
  }
}
